import { render } from "./CaseMenuItemDND.vue?vue&type=template&id=6c3c72ba&scoped=true"
import script from "./CaseMenuItemDND.vue?vue&type=script&lang=js"
export * from "./CaseMenuItemDND.vue?vue&type=script&lang=js"

import "./CaseMenuItemDND.vue?vue&type=style&index=0&id=6c3c72ba&scoped=true&lang=scss"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3c72ba"]])

export default __exports__